import React from 'react'

import Textarea from '@/components/textarea'
import Input from '@helios/shared/components/input'
import hasNonEmptyItems from '@helios/shared/utils/has-non-empty-items'

import type {State, Data, SetValue} from '../expense-policy-builder'
import {StepWrapper} from '../expense-policy-builder'
import Sidebar from '../sidebar'

interface Props {
    state: State['gifts']
    setValue: SetValue<'gifts'>
    resetValues: () => void
    togglePreview: () => void
    data: Data['gifts'][number] & {
        sidebar: Data['sidebar'][number]
    }
    children: React.ReactNode
}

const Gifts = ({children, state, setValue, resetValues, togglePreview, data}: Props) => (
    <StepWrapper>
        <Sidebar
            title={data.title}
            subtitle={data.subtitle}
            onSkip={resetValues}
            togglePreview={togglePreview}
            disableNext={!hasNonEmptyItems([state])}
            data={data.sidebar}
        >
            <Input
                label={data.client_amount}
                placeholder={data.client_amount_placeholder}
                value={state.clientAmount}
                onChange={(value) => setValue('clientAmount', value)}
                autoFocus
            />

            <Input
                label={data.employee_amount}
                placeholder={data.employee_amount_placeholder}
                value={state.employeeAmount}
                onChange={(value) => setValue('employeeAmount', value)}
            />

            <Textarea
                label={data.extra}
                placeholder={data.extra_placeholder}
                value={state.extra}
                onChange={(value) => setValue('extra', value)}
            />
        </Sidebar>

        {children}
    </StepWrapper>
)

export default Gifts
